export default __webpack_public_path__ + "static/media/amex.ab5dba2f.svg";